import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Scroll to the top on forward navigations to a new page. Two exceptions,
 * both required by the Signal Desk "background location" modal pattern:
 *   - When a card opens as a modal overlay, the URL changes to
 *     /signal/:slug but `state.background` is set - the feed underneath must
 *     stay exactly where it was, so we don't scroll it to the top.
 *   - On POP (browser back/forward, and the modal's own navigate(-1) close),
 *     let the browser restore the previous scroll position instead of
 *     forcing the page to the top.
 */
export const ScrollToTop = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    const isModalOverlay = Boolean((location.state as { background?: unknown } | null)?.background);
    if (isModalOverlay || navigationType === "POP") return;
    window.scrollTo(0, 0);
  }, [location.pathname, location.state, navigationType]);

  return null;
};
